import { useNavigate } from "react-router-dom";
import EditButton from "./EditButton";
import Input from "./Input";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/api";

export default function InformationCard({ accountData }) {
  const navigate = useNavigate();
  const isOnlyDigits = (value) => {
    if (!value) {
      return true;
    }
    return /^[0-9۰-۹]+$/.test(value);
  };
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [validation, setValidation] = useState({
    postal_code: true,
  });
  useEffect(() => {
    if (accountData) {
      setCurrentData({ ...accountData });
      setEditData({ ...accountData });
    }
  }, [accountData]);
  useEffect(() => {
    if (editData) {
      if (!isOnlyDigits(editData?.postal_code)) {
        setValidation({ postal_code: false });
      } else {
        setValidation({ postal_code: true });
      }
    }
  }, [isEditing, editData]);
  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    if (isSaving) return;
    setIsEditing(false);
    setEditData({ ...(currentData || accountData || {}) });
  };

  const handleSave = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (isSaving) return;
    // Here you could add save logic (API call, state update, etc.)
    if (!validation.postal_code) {
      return;
    }
    setIsSaving(true);
    // Here you could add save logic (API call, state update, etc.)
    try {
      let response = await fetch(
        `${API_BASE_URL}auth/trader/info/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify({
            country: editData?.country,
            city: editData?.city,
            address: editData?.address,
            postal_code: editData?.postal_code,
          }),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}auth/trader/info/`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify({
              country: editData?.country,
              city: editData?.city,
              address: editData?.address,
              postal_code: editData?.postal_code,
            }),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setCurrentData((pre) => ({ ...pre, ...data }));
      setEditData((pre) => ({ ...pre, ...data }));
      localStorage.setItem("fn", data?.fn || "");
      localStorage.setItem("ln", data?.ln || "");
      setIsEditing(false);
    } catch (error) {
      console.error("Error fetching account data:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="w-full max-w-3xl rounded-2xl p-4 flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <span className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
          اطلاعات آدرس
        </span>
        <EditButton
          isEditing={isEditing}
          isSaving={isSaving}
          onEdit={handleEdit}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </div>

      <form
        className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6"
        onSubmit={handleSave}
      >
        <Input
          label="کشور"
          inputSample={currentData?.country || ""}
          value={editData?.country || ""}
          type="text"
          id="country"
          name="country"
          isReadOnly={!isEditing}
          isAuotComplete={true}
          onChange={(e) =>
            setEditData((pre) => ({ ...pre, country: e.target.value }))
          }
        />
        <Input
          label="شهر"
          inputSample={currentData?.city || ""}
          value={editData?.city || ""}
          type="text"
          id="city"
          name="city"
          isReadOnly={!isEditing}
          isAuotComplete={true}
          onChange={(e) =>
            setEditData((pre) => ({ ...pre, city: e.target.value }))
          }
        />
        <Input
          label="آدرس"
          inputSample={currentData?.address || ""}
          value={editData?.address || ""}
          type="text"
          id="address"
          name="address"
          isReadOnly={!isEditing}
          isAuotComplete={true}
          onChange={(e) =>
            setEditData((pre) => ({ ...pre, address: e.target.value }))
          }
        />
        <Input
          label="کد پستی"
          inputSample={currentData?.postal_code || ""}
          value={editData?.postal_code || ""}
          type="text"
          id="postal"
          name="postal"
          isNumeric={true}
          isReadOnly={!isEditing}
          isAuotComplete={true}
          onChange={(e) =>
            setEditData((pre) => ({ ...pre, postal_code: e.target.value }))
          }
        />
      </form>
      {!validation.postal_code && (
        <p className="text-red-500 text-sm">کد‌ پستی وارد شده صحیح نمی باشد</p>
      )}
    </div>
  );
}
